import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-cancel-confirmation',
  templateUrl: './cancel-confirmation.component.html'
})
export class CancelConfirmationComponent implements OnInit {
  @Input() localeView: string;
  @Input() lang: string;

  private ngUnsubscribe$: Subject<boolean> = new Subject();
  private dialogRef: any;

  constructor(private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit() {
  }

  openDialog(content: any): void {
    this.dialogRef = this.dialog.open(content, {
      panelClass: 'custom-dialog-container'
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  goBackToStart(): void {
    let action = 'opt';

    switch (true) {
      case this.localeView.startsWith('OPT_OUT'):
        action = 'optout'
        break;
      case this.localeView.startsWith('OPT_DWN'):
        action = 'optdwn'
        break;
      case this.localeView.startsWith('OPT_UP'):
        action = 'optup'
        break;
      case this.localeView.startsWith('OPT_IN'):
        action = 'optin'
        break;
      default:
        action = 'all';
        break;
    }

    this.router.navigateByUrl(`customer/${action}/${this.lang}`);
    this.dialog.closeAll();
  }
}
